export default __webpack_public_path__ + "static/media/095-turtle.30749531.svg";